(() => {
  const rootPath = () => window.Shopify?.routes?.root || '/';
  async function post(path, payload) {
    const response = await fetch(`${rootPath()}cart/${path}.js`, { method: 'POST', body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin' });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'The cart could not be updated.');
    return result;
  }
  function publish(cart, options = {}) {
    if (cart) {
      document.querySelectorAll('[data-header-cart-count]').forEach(count => { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; });
      if (options.countLabel) document.querySelectorAll('[data-header-cart-link]').forEach(link => link.setAttribute('aria-label', options.countLabel.replace('__COUNT__', String(cart.item_count))));
    }
    document.dispatchEvent(new CustomEvent('varellea:cart:updated', { detail: { cart, source: options.source || 'refresh', openDrawer: Boolean(options.openDrawer) } }));
    return cart;
  }
  window.VarelleaCart = Object.freeze({
    async add(form) {
      const response = await fetch(`${rootPath()}cart/add.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Could not add this item to the cart.');
      return result;
    },
    async change(key, quantity) { return post('change', { id: key, quantity }); },
    async updateNote(note) { return post('update', { note }); },
    publish,
    async refresh(countLabel, options = {}) {
      let cart = null;
      try { const response = await fetch(`${rootPath()}cart.js`, { credentials: 'same-origin' }); if (response.ok) cart = await response.json(); } catch (_) {}
      return publish(cart, { ...options, countLabel });
    }
  });
})();
